import { Panel } from '@playcanvas/pcui/react';
import React from 'react';

import { SetProperty, ObserverData } from '../../types';
import { Detail } from '../components';

const bytesToSizeString = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

class TexturePanel extends React.Component<{ 
    sceneData: ObserverData['scene'], 
    setProperty: SetProperty 
}> {
    shouldComponentUpdate(nextProps: Readonly<{ 
        sceneData: ObserverData['scene']; 
        setProperty: SetProperty; 
    }>): boolean {
        return (
            JSON.stringify(nextProps.sceneData.textures) !== JSON.stringify(this.props.sceneData.textures)
        );
    }

    render() {
        const scene = this.props.sceneData;
        const textures = scene.textures || [];
        const hasTextures = textures.length > 0;

        return (
            <Panel 
                headerText={`TEXTURES (${textures.length})`} 
                class='scene-texture-panel' 
                enabled={hasTextures} 
                collapsible={true}
                collapsed={textures.length > 10} // Auto-collapse if many textures
            >
                {hasTextures && (
                    <div className='texture-list'>
                        {textures.map((texture, index) => (
                            <Panel 
                                key={`${texture.name}-${index}`}
                                headerText={texture.filename}
                                class='texture-item-panel'
                                collapsible={true}
                                collapsed={true}
                            >
                                <Detail label='Name' value={texture.name} />
                                <Detail label='Dimensions' value={`${texture.width} × ${texture.height}`} />
                                <Detail label='Format' value={texture.format} />
                                <Detail label='Type' value={texture.type} />
                                <Detail label='Size' value={bytesToSizeString(texture.size)} />
                            </Panel>
                        ))}
                    </div>
                )}
            </Panel>
        );
    }
}

export default TexturePanel; 